import { Trans, useTranslation } from 'react-i18next'
import { useFetchPendingPayments } from 'queries/premiums'

import { Alert } from '@cmsgov/design-system'
import { Card } from '@cmsgov/ds-medicare-gov'
import OnlinePaymentCard from 'containers/Premiums/components/paymentHistory/OnlinePaymentsCard/OnlinePaymentCard'
import { MyInternalLink } from 'components/MyLink/MyInternalLink'
import Skeleton from 'react-loading-skeleton'
import { MyLinkClickHandler } from 'components/MyLink'
import { useEvent } from 'hooks/useEvent'

export const OnlinePayments = () => {
  const { t } = useTranslation('premiumsHistory')

  const { data, isError, isLoading, isSuccess } = useFetchPendingPayments()

  const payments = data ?? []

  const Link1 = ({ children }: {children?: React.ReactNode}) => {
    const { fireEvent } = useEvent('premiumsHistory')
    const handleClick: MyLinkClickHandler = (params) => fireEvent('premiums_paymenthistory_makeapayment_click', params)
    return (
      <MyInternalLink to="/premiums/make-a-payment" onClick={handleClick}>{children}</MyInternalLink>
    )
  }

  return (
    <div className="ds-l-container">
      <h2 className="ds-text-heading--lg">{t('onlinePayments.heading')}</h2>
      {isError && (
        <Alert variation='error' heading={t('onlinePayments.errorAlert.heading')} className='ds-u-measure--wide'>
          {t('onlinePayments.errorAlert.content')}
        </Alert>
      )}

      {isSuccess && payments.length === 0 && (
        <Alert heading={t('onlinePayments.noRecordsAlert.heading')} className='ds-u-measure--wide'>
          <Trans t={t} i18nKey='onlinePayments.noRecordsAlert.content' components={{
            link1: <Link1 />
          }} />
        </Alert>
      )}

      {!isError && (
        <>
          <div className="ds-l-row">
            <div className="ds-l-md-col--11 ds-l-sm-col--12">
              {!isLoading && payments.length > 0 && (
                <Trans t={t} i18nKey={'onlinePayments.content'} components={{
                  link1: <Link1 />
                }} />
              )}
            </div>
          </div>
          <div className="ds-l-row">
            <div className='ds-l-md-col--12 ds-l-sm-col--12 ds-u-margin-top--3'>
              {isLoading && <OnlinePaymentLoading />}

              {!isLoading && payments.length > 0 && payments.map(item => (
                <OnlinePaymentCard
                  onlinePayment={item}
                  className='ds-u-margin-bottom--2'
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const OnlinePaymentLoading = () => {
  return (
    <Card className='ds-u-padding-left--3 ds-u-padding-right--5 ds-u-padding-y--1'>
      <div data-testid='online-payment-card ds-l-container'>
        <div className='ds-l-row'>
          <div className='ds-l-col--12 ds-l-md-col--2'>
            <Skeleton width={80} height={24} />
            <Skeleton width={126} height={50} />
          </div>

          <div className='ds-l-col--12 ds-l-md-col--4'>
            <Skeleton width={210} height={24} />
            <Skeleton width={294} height={50} />
          </div>

          <div className='ds-l-col--12 ds-l-md-col--3'>
            <Skeleton width={170} height={24} />
            <Skeleton width={216} height={50} />
          </div>

          <div className='ds-l-col--12 ds-l-md-col--3'>
            <Skeleton width={208} height={80} />
          </div>
        </div>
      </div>
    </Card>
  )
}
